import { cn } from "@/lib/utils";
import { HTMLAttributes, forwardRef } from "react";

interface StackProps extends HTMLAttributes<HTMLDivElement> {
  spacing?: "xs" | "sm" | "md" | "lg" | "xl" | "2xl";
  align?: "start" | "center" | "end" | "stretch";
  dividers?: boolean;
}

const spacingClasses = {
  xs: "gap-2",
  sm: "gap-4",
  md: "gap-6",
  lg: "gap-8",
  xl: "gap-12",
  "2xl": "gap-16",
};

const alignClasses = {
  start: "items-start",
  center: "items-center",
  end: "items-end",
  stretch: "items-stretch",
};

/**
 * Vertical stack with consistent spacing.
 * Perfect for vertical rhythm and section spacing.
 */
const Stack = forwardRef<HTMLDivElement, StackProps>(
  ({ spacing = "md", align = "stretch", dividers = false, className, children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn(
          "flex flex-col",
          spacingClasses[spacing],
          alignClasses[align],
          dividers && "divide-y divide-border",
          className
        )}
        {...props}
      >
        {children}
      </div>
    );
  }
);

Stack.displayName = "Stack";

export { Stack };
